// removed by extract-text-webpack-plugin
module.exports = {"tray":"tray__tray--ca9a31aa","trayButton":"tray__trayButton--d686c9c1","trayIcon":"tray__trayIcon--8f8ed167","trayIconFlipped":"tray__trayIconFlipped--fe6758cc"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/ui/tray.scss
// module id = 421
// module chunks = 0